// extracted by css-extract-rspack-plugin
export default {"formGroup":"_1e163fdc","shorten":"_631b96ac"};